import { createContext } from 'react';

interface CurrentProductContext {
  productId: string;
}

export const CurrentProductContext = createContext<CurrentProductContext>({
  productId: ''
});
